// temporary solution to remove typename key for inputs in redux
export default function removeTypename<T>(
	initialObj: T & { __typename?: string }
) {
	const { __typename, ...clone } = initialObj;

	return clone;
}
